/**
 * Organization onboarding
 */
export default function () {
  if (document.querySelector('form[name="app_organization_onboarding_user"]')) {
    // eslint-disable-next-line no-unused-expressions
    import(
      /* webpackChunkName: "organization-onboarding-one" */
      '../_03_organisms/organization/onboarding-step-one'
    ).then(({ default: onboarding }) => {
      onboarding();
    });
  }

  if (document.querySelector('form[name="app_organization_onboarding_password"]')) {
    // eslint-disable-next-line no-unused-expressions
    import(
      /* webpackChunkName: "organization-onboarding-two" */
      '../_03_organisms/organization/onboarding-step-two'
    ).then(({ default: onboarding }) => {
      onboarding();
    });
  }
}
